// src/components/Pagination.js
import React from "react";

export default function Pagination({ current, total, onChange }) {
  const show = 5;
  let start = Math.max(1, current - Math.floor(show / 2));
  let end = Math.min(start + show - 1, total);
  if (end === total) start = Math.max(1, end - show + 1);

  const go = (p) => {
    if (p >= 1 && p <= total && p !== current) {
      onChange(p);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <ul className="dajc-pagination">
      <li className={current === 1 ? "disabled" : ""}>
        <button onClick={() => go(1)}><i className="bi bi-chevron-double-left" /></button>
      </li>
      <li className={current === 1 ? "disabled" : ""}>
        <button onClick={() => go(current - 1)}><i className="bi bi-chevron-left" /></button>
      </li>
      {start > 1 && <li className="disabled"><span>…</span></li>}
      {Array.from({ length: end - start + 1 }, (_, i) => start + i).map((p) => (
        <li key={p} className={current === p ? "active" : ""}>
          <button onClick={() => go(p)}>{p}</button>
        </li>
      ))}
      {end < total && <li className="disabled"><span>…</span></li>}
      <li className={current === total ? "disabled" : ""}>
        <button onClick={() => go(current + 1)}><i className="bi bi-chevron-right" /></button>
      </li>
      <li className={current === total ? "disabled" : ""}>
        <button onClick={() => go(total)}><i className="bi bi-chevron-double-right" /></button>
      </li>
    </ul>
  );
}